import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import type { Filters } from '../types/dashboard';
import { DEFAULT_FILTERS, resolveTerritoryIds } from '../utils/filters';
import { aopById } from '../utils/territory';
interface FilterContextValue {
  filters: Filters;
  update: (patch: Partial<Filters>) => void;
  reset: () => void;
  isDefault: boolean;
}
const FilterContext = createContext<FilterContextValue | null>(null);
export function FilterProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [filters, setFilters] = useState<Filters>(DEFAULT_FILTERS);
  const update = useCallback((patch: Partial<Filters>) => {
    setFilters(prev => {
      const next = {
        ...prev,
        ...patch
      };
      if (patch.territories || patch.coach) {
        const allowed = new Set(resolveTerritoryIds(next));
        next.aops = next.aops.filter(a => allowed.has(aopById.get(a)?.territory.id ?? ''));
      }
      return next;
    });
  }, []);
  const reset = useCallback(() => setFilters(DEFAULT_FILTERS), []);
  const isDefault = JSON.stringify(filters) === JSON.stringify(DEFAULT_FILTERS);
  const value = useMemo(() => ({
    filters,
    update,
    reset,
    isDefault
  }), [filters, update, reset, isDefault]);
  return <FilterContext.Provider value={value} data-id="element-765" data-mp="3m1gjta2vtqop">{children}</FilterContext.Provider>;
}
export function useFilters(): FilterContextValue {
  const ctx = useContext(FilterContext);
  if (!ctx) throw new Error('useFilters must be used inside FilterProvider');
  return ctx;
}